import { WarningIcon } from "~/src/components/Icons/Icons";
import Text, { TextVariant } from "~/src/components/Text/Text";

export interface FieldProps {
  label: string;
  value: JSX.Element | string | null | undefined;
  show?: boolean;
  warning?: boolean;
}

export default function Field({ label, value, show = true, warning }: FieldProps): JSX.Element {
  return show ? (
    <li className={`px-4 ${warning ? "bg-ldir-orange-700" : ""} `}>
      <dl className={`${label != "" ? "border-t py-2" : ""}  border-ldir-blue-pale `}>
        <dt className="text-lg">{label}</dt>
        <dd className="flex gap-2">
          {warning && <WarningIcon />}
          <div className="w-full">
            {typeof value == "string" ? (
              <Text bold variant={TextVariant.large} className="wrap-break-word">
                {value}
              </Text>
            ) : (
              value
            )}
          </div>
        </dd>
      </dl>
    </li>
  ) : (
    <></>
  );
}
